const THEMES = ["light", "dark"];

const Theme = function (global) {
    const log = global.log.getLogger("f_mtac.application.theme");
    log.setLevel(log.levels.WARN);

    const get_stored_theme = () => global.configuration.app?.theme;
    const set_stored_theme = (theme) => {
        global.configuration.app.theme = theme;
        global.configuration.commit_store("app");
    };

    // the commented part can be used to match the Tacteam theme to the OS one
    this.get_preferred_theme = () => get_stored_theme() || "dark"; //(window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

    this.apply_theme = (theme) => {
        log.debug("Theme.apply", theme);
        if (theme === "auto") {
            document.documentElement.setAttribute("data-bs-theme", window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
        } else {
            document.documentElement.setAttribute("data-bs-theme", theme);
        }
    };

    this.toggle = () => {
        const new_theme = this.get_preferred_theme() === "light" ? "dark" : "light";
        set_stored_theme(new_theme);
        this.apply_theme(new_theme);
    };

    // Watch for changes of browser preferred theme
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
        if (!THEMES.includes(get_stored_theme())) {
            this.apply_theme(this.get_preferred_theme());
        }
    });
};

export default Theme;
